// React Thirty Party Library
import React, { useState } from "react";
import { Layout as LayoutAntd } from "antd";
import { useSelector } from "react-redux";

// Constants Library

import { TEMPLATE } from "../../v1/constants";

// Components Library
import { Content, Header, Sidebar } from "./components/index";
import { ModalSuspend } from "../../v1/components";

// Handler Library

// Services Library

// Redux Actions
import { REDUX as REDUX_UTIL } from "../../v1/services/util";

// Styles Library

const { reduxStoreWrapper } = REDUX_UTIL;

const LayoutContainer = (props) => {
  const { collapsed, setCollapsed } = props;

  const company = useSelector(reduxStoreWrapper("company.byCOID"));
  const user = useSelector(reduxStoreWrapper("user"));

  const { uroleid, status } = user;

  return (
    <LayoutAntd>
      <Sidebar collapsed={collapsed} />

      {(uroleid === "EMR" && status === 2) || company.status === 2 ? (
        <ModalSuspend
          setmodal={TEMPLATE.MODAL.MODAL_ACTION.account_suspend}
        ></ModalSuspend>
      ) : (
        <LayoutAntd>
          <Header collapsed={collapsed} setCollapsed={setCollapsed} />
          <Content collapsed={collapsed}>{props.children}</Content>
        </LayoutAntd>
      )}
    </LayoutAntd>
  );
};

export default LayoutContainer;
